// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"784f6c3e","623":"7f47475a","976":"c6ea4c90"}[chunkId] + ".chunk.js";
};